import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { Editor } from '@tiptap/core'
import { DragHandle } from '@tiptap/extension-drag-handle'
import StarterKit from '@tiptap/starter-kit'
import { TiptapDraggableDirective, TiptapEditorDirective } from 'ngx-tiptap'
import { Call } from '../../calls.service'

@Component({
  selector: 'app-tiptap-editor',
  standalone: true,
  imports: [CommonModule, FormsModule, TiptapEditorDirective, TiptapDraggableDirective],
  templateUrl: './tiptap-editor.component.html',
  styleUrl: './tiptap-editor.component.scss',
})
export class TiptapEditorComponent implements OnDestroy {
  @Input({ required: true })
  call!: Call

  @Input({ required: true })
  canUserEdit!: boolean

  editor = new Editor({
    extensions: [StarterKit, DragHandle],
    editable: this.canUserEdit,
  })

  value = '<p>Hello, World!</p>'

  ngOnDestroy(): void {
    this.editor.destroy()
  }
}
